import styles from './ActivityCard.module.scss';

/** Colour family a count pill renders in — red for alerts, blue for connections, amber when the
 *  count was computed on partial data (D27a). */
export type ActivityPillTone = 'alerts' | 'connections' | 'warning';

export const ACTIVITY_PILL_TONE_CLASS: Record<ActivityPillTone, string> = {
    alerts: styles.PillAlerts,
    connections: styles.PillConnections,
    warning: styles.PillWarning,
};
